import withPopupMessage from "Components/withPopupMessage";
import PasswordManager from "./passwordManager";
export default withPopupMessage(PasswordManager);
